import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'iw-ghost-box',
  templateUrl: './ghost-box.component.html',
  styleUrls: ['./ghost-box.component.scss']
})
export class GhostBoxComponent implements OnInit {
  @Input() containerClass: string | Array<string> = '';
  @Input() boxClass: string | Array<string> = '';
  @Input() iconClass: string | Array<string> = '';
  @Input() text = '';
  @Input() hidden = false;
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  /**
   * Evento click de la caja.
   *
   * @memberof GhostBoxComponent
   */
  clickedFn() {
    this.clicked.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ghost-box/ghost-box.component.ts